@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.logo {
    svg {
        width: 125px;
    }
}

.list {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 3vw;
    align-items: center;
    text-transform: uppercase;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        gap: 1.5vw;
    }
}

.link {
    color: var(--color-black);
    font-weight: 700;
    text-decoration: none;

    &:hover {
        color: var(--color-crimson);
    }
}
